window.GIFTBOX_CUSTOM_CART_ITEMS_SELECTORS = [".list-products .cart-product"];

window.GIFTBOX_CUSTOM_CART_REMOVE_INPUTS_SELECTORS = [".cart-product-btn-wrapper input, .cart-product-btn-wrapper #IconPlus-0"];

window.GIFTBOX_CUSTOM_UPDATE_CART = () => {
    if (window.location.pathname !== "/cart") {
        localStorage.setItem("gb_refreshed", "true");
        window.location.reload();
    }
}

addEventListener('DOMContentLoaded', (event) => {
    const cartOpen = localStorage.getItem("gb_refreshed");
    if (cartOpen === "true") {
        setTimeout(() => {
            localStorage.setItem("gb_refreshed", "false");
            // Simulate a click on the cart icon to open the drawer
            let cartIcon = document.querySelector('#cart-icon-bubble');
            if (cartIcon) {
                cartIcon.click();
            }
        }, 1500);
    }
});